import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });

    if (typeof this.props.onError === 'function') {
      this.props.onError(error, errorInfo);
    }
  }

  HandleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  HandleGoHome = () => {
    try {
      window.localStorage.clear();
    } catch (error) {
      console.warn('localStorage clear failed:', error);
    }
    window.location.assign('/');
  };

  HandleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const showDetail = process.env.NODE_ENV !== 'production';

    return (
      <div
        style={{
          padding: 16,
          minHeight: '100vh',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 12,
          fontFamily:
            "'SpoqaHanSansNeo','Pretendard', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700 }}>
          예기치 않은 오류가 발생했습니다.
        </div>
        <div style={{ fontSize: 14, color: '#555' }}>
          잠시 후 다시 시도해 주세요. 문제가 계속되면 앱을 새로고침하거나 홈으로
          이동해 주세요.
        </div>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button type="button" onClick={this.HandleReset}>
            다시 시도
          </button>
          <button type="button" onClick={this.HandleGoHome}>
            홈으로
          </button>
          <button type="button" onClick={this.HandleReload}>
            앱 새로고침
          </button>
        </div>

        {showDetail && this.state.error && (
          <pre
            style={{
              marginTop: 8,
              padding: 12,
              background: '#111',
              color: '#fff',
              borderRadius: 8,
              overflowX: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontSize: 12,
            }}
          >
            {String(this.state.error?.stack || this.state.error)}
            {'\n'}
            {String(this.state.errorInfo?.componentStack || '')}
          </pre>
        )}
      </div>
    );
  }
}
